import React from 'react';

import { hint } from 'src/components/molecules/AddressSearch/styles/styles';

export type HintProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>;

export const Hint = (props: HintProps) => (
  <p css={hint} {...props}>
    {props.children}
  </p>
);
